import { type DatabaseReference } from "firebase/database";
import { auth, getAppCheckToken } from "@domain/api/firebase/firebase";

const fetchWithRetry = async (url: string, retries = 5, delay = 1000): Promise<Response> => {
    try {
        return await fetch(url, { headers: { "X-Firebase-AppCheck": await getAppCheckToken() } });
    } catch (error) {
        if (error instanceof TypeError && error.message.includes("Failed to fetch") && retries > 0) {
            await new Promise((resolve) => setTimeout(resolve, delay));
            return fetchWithRetry(url, retries - 1, delay);
        }
        throw error;
    }
};

export const fetchShallow = async (ref: DatabaseReference): Promise<Record<string, true> | null> => {
    const accessToken = await auth.currentUser?.getIdToken();
    if (!accessToken) {
        return null;
    }
    const r = await fetchWithRetry(`${ref.toString()}/.json?shallow=true&auth=${accessToken}`);
    if (r.status === 401) {
        return null;
    }
    return r.json();
};
